import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon } from 'lucide-react';
export function CostOfInaction() {
  const costs = [{
    problem: 'Recetas de YouTube que no te quedan igual',
    cost: 'Ingredientes tirados, plata perdida'
  }, {
    problem: 'Sin fórmula de precios',
    cost: 'Trabajás horas y no ganás nada'
  }, {
    problem: 'Packaging armado con lo que tenés',
    cost: 'Vergüenza de mostrar el producto'
  }, {
    problem: 'Sin sistema de redes',
    cost: 'Nunca llegás a nuevos clientes'
  }, {
    problem: 'Sin las recetas Sin TACC',
    cost: 'Perdés un mercado enorme'
  }, {
    problem: 'Otro fin de semana sin vender nada',
    cost: 'El mismo ciclo, el mes que viene'
  }];
  return <section className="w-full bg-[#F7F2EA] bg-texture py-16 md:py-24" data-id="element-40">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-42">
          <div className="text-center mb-12" data-id="element-43">
            <div className="flex justify-center mb-6" data-id="element-44">
              <div className="bg-white border border-[#E7DDD2] p-4 rounded-full shadow-sm" data-id="element-45">
                <ScaleIcon className="w-10 h-10 text-[#B66A2C]" strokeWidth={1.5} data-id="element-46" />
              </div>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2B1F] mb-4" data-id="element-47">
              ¿Cuánto te cuesta no tenerlo?
            </h2>
          </div>

          <div className="bg-white border border-[#E7DDD2] rounded-3xl overflow-hidden mb-12 shadow-premium max-w-4xl mx-auto" data-id="element-48">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6 bg-[#F3ECE2] border-b border-[#E7DDD2]" data-id="element-49">
              <div className="font-bold text-[#3E2B1F] text-lg" data-id="element-50">
                Sin el Mega Pack
              </div>
              <div className="font-bold text-[#C96B17] text-lg" data-id="element-51">Costo real</div>
            </div>

            {costs.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6 border-b border-[#E7DDD2] last:border-b-0 hover:bg-[#F7F2EA] transition-colors" data-id="element-52">
                <div className="text-[#3E2B1F]/90 text-base font-medium" data-id="element-53">
                  {item.problem}
                </div>
                <div className="text-[#C96B17] font-bold text-base" data-id="element-54">
                  {item.cost}
                </div>
              </motion.div>)}
          </div>

          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="font-serif text-3xl md:text-5xl font-bold text-[#B66A2C] text-center" data-id="element-55">
            La próxima semana puede ser diferente.
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}